module.exports = __webpack_public_path__ + "img/DSC_1113.a488742d.jpg";